<template>
  <router-view class="full-router-view"> </router-view>
</template>

<script>
export default {};
</script>

<style>
.full-router-view {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #f3f0ea;
  z-index: 999;
}
</style>
